import { getStaticImageUrl } from 'client/utils/image-helpers';

export const PAGE_DISPLAY_NAME = 'Car Dealerships Near Me';
export const DEFAULT_CATEGORY = {
  DEFAULT: [
    {
      adjustedPhotoUrl: getStaticImageUrl('/img/dealer-thanks/car-dealership-default-image-1920x1280_v2.jpg'),
      contentType: 'jpeg',
      order: 0,
      isDefaultSlide: true,
    },
  ],
};
export const certifiedPreOwnedText = 'CERTIFIED PRE-OWNED';
